(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initBrandBelt(scope) {
    var belts = scope.querySelectorAll('[data-brand-belt]');

    belts.forEach(function (belt) {
      if (belt.getAttribute('data-brand-belt-ready') === 'true') return;
      belt.setAttribute('data-brand-belt-ready', 'true');

      var toggle = belt.querySelector('[data-brand-belt-toggle]');
      var pauseIcon = belt.querySelector('[data-brand-belt-pause]');
      var playIcon = belt.querySelector('[data-brand-belt-play]');
      var originalSet = belt.querySelector('.qn-brand-belt__set:not([aria-hidden="true"])');

      if (!toggle || !originalSet || reducedMotion.matches) return;

      toggle.hidden = false;

      toggle.addEventListener('click', function () {
        var paused = belt.classList.toggle('is-user-paused');
        toggle.setAttribute('aria-pressed', String(paused));
        toggle.setAttribute('aria-label', paused ? 'Play moving brands' : 'Pause moving brands');
        pauseIcon.hidden = paused;
        playIcon.hidden = !paused;
      });

      function startBelt() {
        var images = Array.prototype.slice.call(originalSet.querySelectorAll('img'));
        var ready = images.map(function (image) {
          if (image.decode) return image.decode().catch(function () {});
          if (image.complete) return Promise.resolve();
          return new Promise(function (resolve) {
            image.addEventListener('load', resolve, { once: true });
            image.addEventListener('error', resolve, { once: true });
          });
        });

        Promise.all(ready).then(function () {
          window.requestAnimationFrame(function () {
            belt.classList.add('is-started');

            if ('IntersectionObserver' in window) {
              var visibilityObserver = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                  belt.classList.toggle('is-offscreen', !entry.isIntersecting);
                });
              });
              visibilityObserver.observe(belt);
            }
          });
        });
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            observer.unobserve(belt);
            startBelt();
          });
        }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });

        observer.observe(belt);
      } else {
        startBelt();
      }
    });
  }

  function setPageVisibility() {
    document.querySelectorAll('[data-brand-belt]').forEach(function (belt) {
      belt.classList.toggle('is-page-hidden', document.hidden);
    });
  }

  initBrandBelt(document);
  document.addEventListener('visibilitychange', setPageVisibility);
  document.addEventListener('shopify:section:load', function (event) {
    initBrandBelt(event.target);
  });
})();
